import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { langFromPath, localizePath, isNonLocalized } from "./locale";

// Drop-in per <Link> di react-router che mantiene automaticamente il prefisso
// lingua attivo (/en, /de) sui percorsi interni, così la navigazione non
// riporta l'utente alla versione italiana.
export const Link = React.forwardRef(function Link({ to, ...rest }, ref) {
  const location = useLocation();
  const lang = langFromPath(location.pathname);

  let target = to;
  if (typeof to === "string" && to.startsWith("/") && !to.startsWith("//") && !isNonLocalized(to)) {
    target = localizePath(to, lang);
  }
  return <RouterLink ref={ref} to={target} {...rest} />;
});

export default Link;
